import { Card, CardContent, CardHeader } from '@mui/material';
import { PieChart } from '@mui/x-charts';
import { 
  green, 
  blue, 
  orange, 
  purple, 
  blueGrey, 
  brown, 
  deepOrange 
} from '@mui/material/colors';

import { GetDashboardInfoDto } from '@bandido/shared/dtos';
import { OriginatedByChannel } from '@bandido/shared/types';
import { useGetCasesByChannel } from '../hooks/queries';
import { useTranslation } from 'react-i18next';

const ChannelColors = {
  [OriginatedByChannel.WHATSAPP]: green[400],           
  [OriginatedByChannel.CALL]: blue[400],                
  [OriginatedByChannel.EMAIL]: orange[400],             
  [OriginatedByChannel.MANUAL]: purple[400],            
  [OriginatedByChannel.EXTERNAL_INTEGRATION]: blueGrey[400], 
  [OriginatedByChannel.UPLOADED]: brown[400],           
  [OriginatedByChannel.SUPPORT_FORM]: deepOrange[400],  
};

export const CasesByChannelGraph = ({ startDate, endDate, agencyIds }: GetDashboardInfoDto) => {
  const { t } = useTranslation();
  const { data } = useGetCasesByChannel({ startDate, endDate, agencyIds });

  if (!data?.data) return null;

  return (
    <Card>
      <CardHeader title={t('dashboard.casesByChannel')} />
      <CardContent>
        <PieChart
          series={[
            {
              data: data?.data!.map((item, index) => ({
                id: index,
                value: item.count,
                label: item.channel,
                color: ChannelColors[item.channel],
              })),
            },
          ]}
          height={300}
        />
      </CardContent>
    </Card>
  );
};

export default CasesByChannelGraph;
